"use client"

import * as React from "react"

import { cn } from "../../lib/utils"

export interface EarningTier {
  frequency: string
  weeklyAmount: number
  monthlyAmount: number
}

export interface EarningPotentialCardProps {
  className?: string
  title?: string
  tiers: EarningTier[]
  currency?: string
}

function formatAmount(amount: number): string {
  if (amount >= 1000) {
    const k = amount / 1000;
    return k % 1 === 0 ? `${k}K` : `${k.toFixed(1)}K`;
  }
  return amount.toLocaleString();
}

function EarningPotentialCard({
  className,
  title = "Your Earning Potential",
  tiers,
  currency = "$",
}: EarningPotentialCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-black rounded-lg p-4 shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      {/* Title */}
      <h3 className="text-base font-medium text-[#475467] mb-3">{title}</h3>

      {/* Earning Tiers */}
      <div className="flex flex-col gap-2">
        {tiers.map((tier, index) => (
          <div
            key={index}
            className="flex items-center justify-between py-1"
          >
            <span className="text-sm text-[#667085]">{tier.frequency}</span>
            <span className="text-sm font-semibold text-[#ED5AA9]">
              {currency}{formatAmount(tier.monthlyAmount)}/month
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export { EarningPotentialCard }
